import { Row, Col } from 'antd';
import { classifyBrain, classifyBrainFromScore, getEarStats, classifyEar } from '../../../utils/clinical';
import type { IndicatorStatus  } from '../../../utils/clinical';

const COLORS: Record<IndicatorStatus, string> = {
  green: "#16a34a",
  yellow: "#f59e0b",
  red: "#dc2626"
};

const LABELS: Record<IndicatorStatus, string> = {
  green: "Normal",
  yellow: "Intermedio",
  red: "Alterado"
};


interface Props {
  dpoaeState: any;
  reportState: any;
  curves?: any[];
}

type IndicatorProps = {
  title: string;
  status: IndicatorStatus;
  subtitle?: string;
};

function Indicator({ title, status, subtitle }: IndicatorProps) {
  return (
    <div style={styles.card}>
      <div style={styles.title}>{title}</div>

      <div
        style={{
          ...styles.circle,
          backgroundColor: COLORS[status]
        }}
      />

      <div style={styles.label}>{LABELS[status]}</div>

      {subtitle && <div style={styles.subtitle}>{subtitle}</div>}
    </div>
  );
}

export default function ClinicalIndicators({ dpoaeState, reportState }: any) {
    
  const rightStatus = classifyEar(dpoaeState?.right);
  const leftStatus = classifyEar(dpoaeState?.left);

  const rightStats = getEarStats(dpoaeState?.right);
  const leftStats = getEarStats(dpoaeState?.left);
  const brainStatus = classifyBrain(reportState?.result);
  const avg = (arr: any[]) =>
    arr?.reduce((a, b) => a + b.snr, 0) / (arr?.length || 1);

  return (
    <Row gutter={[40, 40]} justify="center">
      <Col xs={24} sm={8}>
        <Indicator
          title="Oído derecho"
          status={rightStatus}
          subtitle={`${rightStats.passes} / ${rightStats.total} frecuencias (${Math.round(rightStats.ratio * 100)}%)`}

        />
      </Col>

      <Col xs={24} sm={8}>
        <Indicator
          title="Oído izquierdo"
          status={leftStatus}
          subtitle={`${leftStats.passes} / ${leftStats.total} frecuencias (${Math.round(leftStats.ratio * 100)}%)`}

        />
      </Col>

      <Col xs={24} sm={8}>
        <Indicator
          title="Riesgo neurodegenerativo"
          status={brainStatus}
          subtitle={
            reportState?.score != null
              ? `Score: ${reportState.score.toFixed(2)}`
              : reportState?.result
          }
        />
      </Col>
    </Row>
  );
}



const styles = {
  card: {
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    padding: 20,
    textAlign: "center" as const
  },
  title: {
    fontWeight: 600,
    marginBottom: 10
  },
  circle: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    margin: "0 auto 10px auto"
  },
  label: {
    fontSize: 14,
    fontWeight: 500
  },
  subtitle: {
    fontSize: 12,
    color: "#6b7280"
  }
};